module.exports = __webpack_public_path__ + "img/2a.e2d47763.jpg";